import { render, staticRenderFns } from "./tap2.vue?vue&type=template&id=b72533ee&scoped=true&"
import script from "./tap2.vue?vue&type=script&lang=js&"
export * from "./tap2.vue?vue&type=script&lang=js&"
import style0 from "./tap2.vue?vue&type=style&index=0&id=b72533ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72533ee",
  null
  
)

export default component.exports